@if (isLoading) {
  <div class="d-flex spinner-container align-items-center justify-content-center">
    <div class="spinner-border text-dark" [style]="borderStyle()" role="status">
      <span class="sr-only">Loading...</span>
    </div>
    @if (loadingText) {
      <span class="loading-spinner__text">{{ loadingText }}</span>
    }
  </div>
}
